import 'es6-promise/auto';
import Vue from 'vue';
import router from './router/index';
import store from './store/index';
import { sync } from 'vuex-router-sync';
import App from './App.vue';
import './assets/stylus/style.styl';
import VueClipboard from 'vue-clipboard2';

Vue.use(VueClipboard)
// import 'mint-ui/lib/style.css';

// 结合vuex和路由
sync(store, router);

export const Root = new Vue({
  router,
  store,
  ...App
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', afterDOMLoaded);
} else {
  afterDOMLoaded();
}

function afterDOMLoaded() {
  //Everything that needs to happen after the DOM has initially loaded.
  Root.$mount('#app');
}

